import {CsvReadItem} from './PromotionQuestionsState';
import api from '../../api';
import {buildValidator} from 'src_common/common/mobx-utils/buildValidator';
import {ResponseUpdateQuestionIO} from './types';
import * as t from 'io-ts';

const decodeResponse = buildValidator('update marketing questions -> ResponseIO', ResponseUpdateQuestionIO, true);

export const updateQuestion = (id: string, question: Partial<CsvReadItem>): Promise<CsvReadItem> => {
    return new Promise((resolve, reject) => {
        const url = `/marketing-questions/${id}`;
        const payload = {
            name: question.name,
            possibleAnswers: question.possibleAnswers,
            active: question.active,
            fileName: question.fileName,
            uploadedAt: question.uploadedAt?.toString()
        };

        api.patch(url, payload)
            .then((data: t.TypeOf<typeof ResponseUpdateQuestionIO>) => {
                const decodeResult = decodeResponse(data);
                if (decodeResult instanceof Error) {
                    reject(decodeResult);
                }
                resolve(data);
            }).catch((error: Error)=>{
                reject(error);
            });
    });
};
